import gql from 'graphql-tag';
import { CHANNEL_FIELDS_FRAGMENT } from './channels';

export const DESKS_SHORT = gql`
query getDesks($getOnlyUsersDesks: Boolean) {
	documents: desks(getOnlyUsersDesks: $getOnlyUsersDesks) {
		_id
		contributors { _id name scopes }
		name
		email
	}
}`;

export const DESKS_COUNTS = gql`
query getDesks($getOnlyUsersDesks: Boolean) {
	documents: desks(getOnlyUsersDesks: $getOnlyUsersDesks) {
		_id
		articleCount
		views
	}
}`;

export const DESK = gql`
query findDeskById($id: ID!) {
	document: findDeskById(id: $id) {
		_id
		name
		contributors { _id name email }
		description
		email
		version
		channels {
			name
		}
	}
}`;

export const DESK_PAGE = gql`
	query document($id: ID!) {
		document: findDeskById(id: $id) {
			_id
			name
			contributors { _id name position phone}
			email
			version
			categories {
				_id
				name
			}
			channels {
				${CHANNEL_FIELDS_FRAGMENT}
			}
		}
	}`;

export const ADD_DESK = gql`
mutation addDesk($item: DeskInputAdd) {
	addDesk(item: $item) {
		_id
		name
		contributors { _id name }
		description
		email
		version
	}
}`;

export const EDIT_DESK = gql`
mutation editDesk($item: DeskInputEdit) {
	editDesk(item: $item) {
		_id
		name
		contributors { _id name }
		description
		email
		version
	}
}`;

export const DELETE_DESK = gql`
mutation deleteDesk($id: ID!){
	deleteDesk(id: $id) {
		_id
	}
}`;
